import { PatientsListColumnName } from '@/shared/config';

import {
  PatientListColumnSettings,
  PatientListColumnVisibility,
  PatientListToggleableColumn,
} from './types';

// Columns the user may show or hide in the All patients table. Patient name
// is the row's identity and link to the profile, so it is never hideable.
export const PATIENT_LIST_TOGGLEABLE_COLUMNS: PatientListToggleableColumn[] = [
  PatientsListColumnName.PatientID,
  PatientsListColumnName.DateOfBirth,
  PatientsListColumnName.Doctors,
  PatientsListColumnName.LastModified,
  PatientsListColumnName.Studies,
];

export const PATIENT_LIST_COLUMNS: PatientsListColumnName[] = [
  PatientsListColumnName.PatientName,
  ...PATIENT_LIST_TOGGLEABLE_COLUMNS,
];

export const PATIENT_LIST_DEFAULT_COLUMN_VISIBILITY: PatientListColumnVisibility =
  {
    [PatientsListColumnName.PatientName]: true,
    [PatientsListColumnName.PatientID]: false,
    [PatientsListColumnName.DateOfBirth]: true,
    [PatientsListColumnName.Doctors]: true,
    [PatientsListColumnName.LastModified]: true,
    [PatientsListColumnName.Studies]: true,
  };

export const PATIENT_LIST_DEFAULT_COLUMN_SETTINGS: PatientListColumnSettings = {
  visibility: PATIENT_LIST_DEFAULT_COLUMN_VISIBILITY,
  widths: {},
};
